import { mbUniversity } from './mb-university'
import { mbCart } from './mb-cart'
import { mbProductLine } from './mb-productLine'
import { common, mbCommon } from './mb-common'
import { mbLoginRegisterPage } from './mb-login-register'
import { mbProduct } from './mb-product'
import { mbForms } from './mb-forms'
import { mbCmsComponents } from './mb-cms-components'
import { mbSearch } from './mb-search'
import { mbCheckout } from './mb-checkout'
import { mbCountry } from './mb-country'
import { mbMyAccount } from './mb-my-account'
import { quickOrder } from './mb-quick-order'
import { address } from './spartacus-translations/address'
import { myAccount } from './spartacus-translations/my-account'
import { product } from './spartacus-translations/product'
import { payment } from './spartacus-translations/payment'
import { pwa } from './spartacus-translations/pwa'
import { user } from './spartacus-translations/user'
import { spCommon } from './spartacus-translations/common'
import { mbPoUpload } from './mb-po-upload'
import { mbMpup } from './mb-mpup'

export const en = {
  common,
  mbCart,
  mbProduct,
  mbProductLine,
  mbLoginRegisterPage,
  mbCommon,
  mbCountry,
  mbForms,
  mbCmsComponents,
  mbSearch,
  mbCheckout,
  mbMyAccount,
  mbUniversity,
  mbPoUpload,
  mbMpup,

  // spartacus translations
  quickOrder,
  address,
  myAccount,
  payment,
  product,
  pwa,
  user,
  spCommon
}
